import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_manage/manage/admin/rate-limits')({
  beforeLoad: () => {
    throw redirect({
      to: '/manage/admin/settings',
      search: { tab: 'rate-limits' },
      replace: true,
    })
  },
})
